"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpFactory = exports.HttpRequestBuilder = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var trimEnd_1 = tslib_1.__importDefault(require("lodash/trimEnd"));
var trimStart_1 = tslib_1.__importDefault(require("lodash/trimStart"));
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var token_1 = require("../token");
var URLSearchParams_1 = require("../url/URLSearchParams");
var HttpRequestBuilder = /** @class */ (function () {
    function HttpRequestBuilder(url) {
        this.securityHeaders = false;
        this.requiredSecurityHeaders = true;
        this.__methods = null;
        this.__headers__ = {};
        this.__timeout = 15 * 1000;
        this._url = url;
    }
    Object.defineProperty(HttpRequestBuilder.prototype, "tokenService", {
        get: function () {
            return di_1.default.getInstance(token_1.TokenService);
        },
        enumerable: false,
        configurable: true
    });
    HttpRequestBuilder.prototype.url = function (url) {
        this._url = url;
        return this;
    };
    /**
     * application / x - www - form - urlencoded | application / json
     **/
    HttpRequestBuilder.prototype.contentType = function (contentType) {
        this._contentType = contentType;
        return this.headers({ "content-type": contentType });
    };
    HttpRequestBuilder.prototype.dataType = function (dataType) {
        this.__dataType__ = dataType;
        return this;
    };
    HttpRequestBuilder.prototype.addSecurityHeaders = function (required) {
        if (required === void 0) { required = true; }
        this.securityHeaders = true;
        this.requiredSecurityHeaders = required;
        return this;
    };
    HttpRequestBuilder.prototype.support = function () {
        var e_1, _a;
        var methods = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            methods[_i] = arguments[_i];
        }
        if (methods.length > 0) {
            this.__methods = this.__methods || {};
            try {
                for (var methods_1 = tslib_1.__values(methods), methods_1_1 = methods_1.next(); !methods_1_1.done; methods_1_1 = methods_1.next()) {
                    var method = methods_1_1.value;
                    var name_1 = method.toLowerCase();
                    this.__methods[name_1] = true;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (methods_1_1 && !methods_1_1.done && (_a = methods_1.return)) _a.call(methods_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return this;
    };
    HttpRequestBuilder.prototype.headers = function (obj) {
        this.__headers__ = tslib_1.__assign(tslib_1.__assign({}, this.__headers__), obj);
        return this;
    };
    HttpRequestBuilder.prototype.timeout = function (timeout) {
        this.__timeout = timeout;
        return this;
    };
    HttpRequestBuilder.prototype.request = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var method, authHeaders;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.__methods) {
                            method = ("" + options.method).toLowerCase();
                            if (!this.__methods[method]) {
                                throw new Error("\u6B64\u63A5\u53E3\u4E0D\u652F\u6301" + options.method + "," + this._url);
                            }
                        }
                        if (!this.securityHeaders) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.tokenService.getSecurityHeaders()];
                    case 1:
                        authHeaders = _a.sent();
                        if (!authHeaders && this.requiredSecurityHeaders) {
                            throw new Error("未登录");
                        }
                        else {
                            this.headers(authHeaders || {});
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, axios_1.default.request(tslib_1.__assign({ url: this._url, headers: this.__headers__, timeout: this.__timeout, responseType: this.__dataType__, cancelToken: new axios_1.default.CancelToken(function (c) {
                                _this.__canceler__ = c;
                            }) }, options))];
                }
            });
        });
    };
    HttpRequestBuilder.prototype.dataSerializer = function (data) {
        if (this._contentType == "application/x-www-form-urlencoded") {
            if (!data) {
                return "";
            }
            return new URLSearchParams_1.URLSearchParams(data).toString();
        }
        return data;
    };
    HttpRequestBuilder.prototype.get = function (query) {
        return this.request({ method: "GET", params: query });
    };
    HttpRequestBuilder.prototype.post = function (data, query) {
        return this.request({
            method: "POST",
            data: this.dataSerializer(data),
            params: query,
        });
    };
    HttpRequestBuilder.prototype.put = function (data, query) {
        return this.request({
            method: "PUT",
            data: this.dataSerializer(data),
            params: query,
        });
    };
    HttpRequestBuilder.prototype.head = function (data, query) {
        return this.request({
            method: "HEAD",
            data: this.dataSerializer(data),
            params: query,
        });
    };
    HttpRequestBuilder.prototype.remove = function (data, query) {
        return this.request({ method: "DELETE", data: this.dataSerializer(data), params: query });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    HttpRequestBuilder.prototype.jsonp = function (query) {
        throw new Error("不支持JSONP" + query);
    };
    HttpRequestBuilder.prototype.stop = function () {
        if (this.__canceler__) {
            this.__canceler__("ajax.abort");
        }
    };
    return HttpRequestBuilder;
}());
exports.HttpRequestBuilder = HttpRequestBuilder;
var HttpFactory = /** @class */ (function () {
    function HttpFactory(baseUrl) {
        this.baseUrl = baseUrl;
    }
    HttpFactory.prototype.url = function (api) {
        var url = trimEnd_1.default(this.baseUrl, "/") + "/" + trimStart_1.default(api, "/");
        return new HttpRequestBuilder(url);
    };
    HttpFactory.diOptions = di_1.default.options({
        name: "httpFactory",
        scope: "Request",
    });
    return HttpFactory;
}());
exports.HttpFactory = HttpFactory;
exports.default = HttpFactory;
